import React from 'react'
import { TextInput } from 'react-native-paper'
import { TextField as StyledTestField } from './styles'

const TextField = (props) => <StyledTestField dense {...props} />

TextField.propTypes = TextInput.propTypes

export default TextField
